import React from "react";

export function CustomersPageHeader() {
  return (
    <div className="mb-8">
      <h1 className="my-0 text-[22px] font-semibold tracking-tight text-[#151515] md:text-[24px]">
        Customers
      </h1>
      <p className="my-0 mt-1.5 max-w-2xl text-[13px] leading-relaxed text-[#6B7280]">
        View all customers who have purchased from your store.
      </p>
    </div>
  );
}
